import { IAgendamento } from "../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import {
    IDocumentoGerados,
    IGerarDocumento,
    IListarCasosDocumentos,
} from "../../Interfaces/VistoriaEntregaChaves/GerarDocumento/GerarDocumentoInterface";
import { IFiltroAtendimentosVistorias } from "../../Interfaces/VistoriaEntregaChaves/ListarAtendimentosVistorias/ListarAtendimentosVistoriasInterfaces";
import {
    IGestaoDeEntregaChavesRequest,
    IGestaoVistoriaResponse,
} from "../../Interfaces/Vistorias/VistoriaEntregaDeChaves/GestaoDeEntregaChaves";
import Axios from "../Config/API";
import AxiosApp from "../Config/APIApp";
import Service from "../Service";

export async function VistoriaEntregaDeChavesServices<
    TResponseType extends
        | IGestaoVistoriaResponse
        | Blob = IGestaoVistoriaResponse
>(
    pagina: number,
    responseBody: IGestaoDeEntregaChavesRequest,
    ExportExcel: boolean
) {
    return Service(
        Axios.post<TResponseType>(
            `/vistoria/casovistoria/listavistorias?PAGINA=${pagina}&exportExcel=${ExportExcel}`,
            responseBody,
            { responseType: ExportExcel ? "blob" : "json" }
        )
    );
}

export async function AdcorpusCasoVistoriaServices(
    ID_PRODUTO: number,
    ID_CONTA: number,
    ID_CONTATO: number
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/adcorpuscasovistoria?idProduto=${ID_PRODUTO}&idConta=${ID_CONTA}&idContato=${ID_CONTATO}`
        )
    );
}
export async function IniciarCasoVistoriaServices(
    ID_PRODUTO: number,
    ID_CONTA: number,
    ID_CONTATO: number
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/IniciarCasoVistoria?idProduto=${ID_PRODUTO}&idConta=${ID_CONTA}&idContato=${ID_CONTATO}`
        )
    );
}

export async function ParalisarCasoVistoriaServices(
    idCaso: number,
    ID_MOTIVO_NAO_PROCEDENCIA: number
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/paralisarcasovistoria?idCaso=${idCaso}&ID_MOTIVO_NAO_PROCEDENCIA=${ID_MOTIVO_NAO_PROCEDENCIA}`
        )
    );
}
export async function VerificarCasoParalisadoVistoriaService(
    requestBody: number[]
) {
    return Service(
        Axios.post<number[]>(
            `/vistoria/casovistoria/verificarcasoparalisado`,
            requestBody
        )
    );
}

export async function ReiniciarCasoVistoriaServices(idCaso: number) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/reiniciarcasovistoria?idCaso=${idCaso}`
        )
    );
}

export async function ReenvioEmailServices(ID_CASO: number) {
    return Service(
        Axios.post(`/home/agendamento/reenviodeemail?ID_CASO=${ID_CASO}`)
    );
}

export async function ReagendarCasoVistoriaServices(idCaso: number) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/reagendarcasovistoria?idCaso=${idCaso}`
        )
    );
}

export async function ExportarExcelAtendimentosVistoriaService(
    SEG_ATENDIMENTOS: string,
    filtro: IFiltroAtendimentosVistorias
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/exportaexcelatendimentosvistoria?SEG_ATENDIMENTOS=${SEG_ATENDIMENTOS}`,
            filtro,
            { responseType: "blob" }
        )
    );
}

export async function CadastrarDataDeCorteServices(
    dtInicio: string,
    dtFim: string,
    idsProdutos: number[] | undefined
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/cadastrardatadecorte?DT_INICIO=${dtInicio}&DT_FIM=${dtFim}`,
            idsProdutos
        )
    );
}

export async function LiberacaoCasosVistoriaEmMassaService(
    idEmpreendimento: number
) {
    return Service(
        Axios.post(
            `/vistoria/casovistoria/liberacaoemmassa?idEmpreendimento=${idEmpreendimento}`
        )
    );
}

export async function PreencherTemplateEmailAgendamentoClienteService(
    idUsuarioTecnico: number,
    idCaso: number,
    idDocumentoTemplate: number
) {
    return Service(
        Axios.post(
            `/home/agendamentoemail/preenchertemplateemailagendamentocliente?idUsuarioTecnico=${idUsuarioTecnico}&idCaso=${idCaso}&idDocumentoTemplate=${idDocumentoTemplate}`
        )
    );
}

export async function ListarHorariosDisponiveisDataDeCorteService(
    idOrganizacao: number,
    idEmpreendimento: number,
    idUnidade: number,
    idUsuarioTecnico: number
) {
    return Service(
        Axios.post<
            Array<{
                Data: string;
                Horarios: [];
            }>
        >(
            `/home/agendamentoemail/listarhorariosdisponiveisdatadecorte?idOrganizacao=${idOrganizacao}&idEmpreendimento=${idEmpreendimento}&idUnidade=${idUnidade}&idUsuarioTecnico=${idUsuarioTecnico}`
        )
    );
}

export async function CriarAgendamentoPorEmailClienteVistoriaService(
    idUsuarioAtendenteCaso: number,
    idOrganizacao: string,
    requestBody: IAgendamento
) {
    return Service(
        Axios.post(
            `/home/agendamentoemail/criaragendamentoporemailclienteentregadechave?idUsuarioAtendenteCaso=${idUsuarioAtendenteCaso}&idOrganizacao=${idOrganizacao}`,
            requestBody
        )
    );
}

export async function PreencherLinkEmailAgendamentoClienteVistoriaService(
    idUsuarioTecnico: number,
    idCaso: number,
    dsAssunto: string,
    requestBody: string
) {
    return Service(
        Axios.post(
            `/home/agendamentoemail/preencherlinkemailagendamentocliente?idUsuarioTecnico=${idUsuarioTecnico}&idCaso=${idCaso}&dsAssunto=${dsAssunto}`,
            requestBody,
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        )
    );
}

export async function GerarDocumentoClienteVistoriaService(
    requestBody: IGerarDocumento,
    FL_SEGUNDA_VIA?: boolean,
    DS_JUSTIFICATIVA?: string
) {
    return Service(
        AxiosApp.post<IDocumentoGerados>(
            `/vistoria/gerardocumento/gerardocumento?FL_SEGUNDA_VIA=${FL_SEGUNDA_VIA}&DS_JUSTIFICATIVA=${DS_JUSTIFICATIVA}`,
            requestBody
        )
    );
}

export async function ListarCasosDocumentosVistoriaService(
    requestBody: IListarCasosDocumentos
) {
    return Service(
        Axios.post<Array<number>>(
            `/vistoria/gerardocumento/listarcasosdocumentos`,
            requestBody
        )
    );
}
